
import { ValidationObserver } from 'vee-validate'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import AuthMixin from '~/mixins/AuthMixin'

@Component<LoginForm>({
  components: { ValidationObserver },
  head() {
    return {
      bodyAttrs: {
        class: this.authState?.matches('loggingIn') ? 'pagemask' : '',
      },
    }
  },
})
export default class LoginForm extends Mixins(AuthMixin) {
  @Prop()
    email?: string

  @Prop({ default: false })
    useModalPortal: boolean

  user = {
    email: '',
    password: '',
  }
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>
  }

  async authMounted() {
    this.user.email = this.email || ''
    this.authMachine.onTransition((state) => {
      if (state.matches('loggedOut.error')) {
        this.$refs.observer?.setErrors({ email: state.context.error })
      }
    })
    if (this.user.email) {
      this.updateEmail(this.user.email)
    }
  }

  updateEmail(value: string) {
    this.authMachine.send('CHANGE_EMAIL', { value })
  }

  updatePassword(value: string) {
    this.authMachine.send('CHANGE_PASSWORD', { value })
  }

  scrolltop() {
    const useraccount = document.querySelector('#user') as HTMLElement
    if (useraccount) useraccount.scrollTop = 0
  }

  async login(validate: () => Promise<boolean>) {
    const valid = await validate()
    if (valid) {
      this.authMachine.send('LOG_IN_EMAIL')
    }
  }
}
